export const PAYMENT_REQUIREMENTS_HISTORY_MODULE_NAME = 'history';

export enum PaymentRequirementsHistoryGetter {
	historyList = 'historyList',
	historyListLoading = 'historyListLoading',
	historyFilters = 'historyFilters',
	historyPageIsEnd = 'historyPageIsEnd',
}

export enum PaymentRequirementsHistoryAction {
	loadHistoryList = 'loadHistoryList',
	loadNextHistoryList = 'loadNextHistoryList',
}

export enum PaymentRequirementsHistoryMutation {
	setHistoryList = 'setHistoryList',
	appendHistoryList = 'appendHistoryList',
	setHistoryListLoading = 'setHistoryListLoading',
	setHistoryFilters = 'setHistoryFilters',
	setHistoryPageIsEnd = 'setHistoryPageIsEnd',
}